import { gql } from '@apollo/client';
import { searchCombo, daysOfWeek } from './utils';

export const abSplitFragment = gql`
  fragment AbSplitFragment on ABSplitFilter {
    splitGroups {
      splitPercentage
    }
  }
`;

export const addUserToListFragment = gql`
  fragment AddUserToListActionFragment on AddUserToListAction {
    emailListId
  }
`;

export const attributeSplitFilterFragment = gql`
  fragment AttributeSplitFilterFragment on FieldSplitFilter {
    field
    splitValues {
      value
      isDefault
    }
  }
`;

export const callWebhookFragment = gql`
  fragment CallWebhookActionFragment on CallWebhookAction {
    endpoint
    workflowWebhookId
    authToken
    permit
    period
  }
`;

export const changeContactFieldFragment = gql`
  fragment ChangeContactFieldActionFragment on ChangeContactFieldAction {
    dataFields
    mergeNestedObjects
  }
`;

export const channelOptimizedFragment = gql`
  fragment ChannelOptimizedFragment on ChannelOptimizedSendAction {
    channels {
      key
      value {
        campaignId
        templateId
      }
    }
  }
`;

export const delayFragment = gql`
  ${daysOfWeek}
  fragment DelayActionFragment on DelayAction {
    delayDays
    delayHours
    delayMinutes
    timeOfDay {
      hour
      minute
      timestamp
      scheduleType
    }
    delayUsingProperty {
      dataType
      field
      delayIsAdditive
    }
    skipDaysOfWeek {
      ...DaysFragment
    }
  }
`;

export const holdUntilReplyActionFragment = gql`
  fragment HoldUntilReplyActionFragment on HoldUntilReplyAction {
    expireDays
    expireHours
    expireMinutes
    replies
  }`;

export const fieldsMatchFragment = gql`
  ${searchCombo}
  fragment FieldsMatchFilterFragment on FieldsMatchFilter {
    matchTriggeringEventFields
    searchQuery {
      ... on SearchCombo {
        combinator
        searchQueries {
          ... on SearchCombo {
            combinator
            searchQueries {
              ... on DataTypeSearchCombo {
                dataType
                minMatch
                maxMatch
                searchCombo {
                  combinator
                  searchQueries {
                    ...QueryTypesFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const removeUserFromListFragment = gql`
  fragment RemoveUserFromListActionFragment on RemoveUserFromListAction {
    emailListId
  }
`;

export const sendEmailFragment = gql`
  fragment SendEmailActionFragment on SendEmailAction {
    campaignId
    templateId
  }
`;

export const sendPushFragment = gql`
  fragment SendPushActionFragment on SendPushAction {
    campaignId
    templateId
  }
`;

export const sendSMSFragment = gql`
  fragment SendSMSActionFragment on SendSMSAction {
    campaignId
    templateId
  }
`;

export const sendInAppFragment = gql`
  fragment SendInAppActionFragment on SendInAppAction {
    campaignId
    templateId
  }
`;

export const sendEmbeddedFragment = gql`
  fragment SendEmbeddedActionFragment on SendEmbeddedAction {
    campaignId
    templateId
  }
`;

export const sendWebPushFragment = gql`
  fragment SendWebPushActionFragment on SendWebPushAction {
    campaignId
    templateId
  }
`;

export const sendWhatsAppFragment = gql`
  fragment SendWhatsAppActionFragment on SendWhatsAppAction {
    campaignId
    templateId
  }
`;

export const modifyChannelFragment = gql`
  fragment ModifyChannelFragment on ModifyChannelSubscriptionAction {
    channelId
    channelIds
    subscribed
  }
`;

export const modifyMessageFragment = gql`
  fragment ModifyMessageFragment on ModifyMessageTypeSubscriptionAction {
    messageTypeId
    messageTypeIds
    subscribed
  }
`;

/* Disabled in preparation for graphql linting */
/* eslint-disable */
export const betaNodeFragments = gql`
  ${addUserToListFragment}
  ${callWebhookFragment}
  ${changeContactFieldFragment}
  ${channelOptimizedFragment}
  ${delayFragment}
  ${holdUntilReplyActionFragment}
  ${fieldsMatchFragment}
  ${removeUserFromListFragment}
  ${sendEmailFragment}
  ${sendPushFragment}
  ${sendSMSFragment}
  ${sendInAppFragment}
  ${sendEmbeddedFragment}
  ${sendWebPushFragment}
  ${sendWhatsAppFragment}
  ${modifyChannelFragment}
  ${modifyMessageFragment}
`;
/* eslint-enable */
